import { cn } from "@/lib/utils";

import { Card } from "./ui/card";

export interface ULThemeCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The content of the card element.
   */
  children: React.ReactNode;
  /**
   * Optional class names for additional styling or overriding default styles.
   */
  className?: string;
}

const ULThemeCard = ({ children, className, ...rest }: ULThemeCardProps) => {
  const themeClasses = cn(
    "px-(length:--ul-theme-spacing-card-padding-x)",
    "py-(length:--ul-theme-spacing-card-padding-y)",
    // The desktop padding tokens (e.g. 100px for hotels-theme) are sized for
    // the ~400-600px card the design assumes - on narrow viewports the card
    // goes full-width, so that much fixed padding would eat most of the
    // screen. Drop back to a fixed 40px below the sm breakpoint.
    "max-sm:px-10 max-sm:py-10",
    "max-sm:rounded-none max-sm:shadow-none max-sm:border-0",
    "theme-universal:bg-widget-bg",
    "sm:theme-universal:border-(--color-widget-border)",
    "sm:theme-universal:rounded-widget",
    "sm:theme-universal:shadow-widget",
    "sm:theme-universal:border-(length:--border-widget)",
    className,
  );

  return (
    <Card className={themeClasses} {...rest}>
      {children}
    </Card>
  );
};

export default ULThemeCard;
